/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_CloseInputs */

const en_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close window`)
};

const ar_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق النافذة`)
};

const bn_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`উইন্ডো বন্ধ করুন`)
};

const de_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fenster schließen`)
};

const es_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar ventana`)
};

const fr_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre`)
};

const pt_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar janela`)
};

const zh_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭窗口`)
};

const tr_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencereyi kapat`)
};

const ru_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть окно`)
};

const pl_chat_close = /** @type {(inputs: Chat_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij okno`)
};

/**
* | output |
* | --- |
* | "Close window" |
*
* @param {Chat_CloseInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_close = /** @type {((inputs?: Chat_CloseInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_CloseInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_close(inputs)
	if (locale === "bn") return bn_chat_close(inputs)
	if (locale === "de") return de_chat_close(inputs)
	if (locale === "es") return es_chat_close(inputs)
	if (locale === "fr") return fr_chat_close(inputs)
	if (locale === "pt") return pt_chat_close(inputs)
	if (locale === "zh") return zh_chat_close(inputs)
	if (locale === "tr") return tr_chat_close(inputs)
	if (locale === "ru") return ru_chat_close(inputs)
	if (locale === "pl") return pl_chat_close(inputs)
	return en_chat_close(inputs)
});